import "./App.css";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import LandingPage from "./pages/LandingPage";
import Faq from "./Components/Faq/Faq";
import NavBar from "./Components/NavBar/NavBar";
import Footer from "./Components/Footer/Footer";
import Download from "./Components/Download/Download";
import i18next from "i18next";
import { initReactI18next } from "react-i18next";
import { English } from "./languages/Eng";
import { French } from "./languages/FRA";
import { Chinese } from "./languages/CHN";
import { Arabic } from "./languages/ARB";
import { Spanish } from "./languages/SPA";
import { Portuguese } from "./languages/POR";
import { German } from "./languages/GER";
import { Dutch } from "./languages/DUT";
i18next.use(initReactI18next).init({
  resources: {
    ENG: {
      translation: English,
    },
    FRA: {
      translation: French,
    },
    CHN: {
      translation: Chinese,
    },
    ARB: {
      translation: Arabic,
    },
    SPA: {
      translation: Spanish,
    },
    POR: {
      translation: Portuguese,
    },
    GER: {
      translation: German,
    },
    DUT: {
      translation: Dutch,
    },
  },
  fallbackLng: "ENG",
});

function App() {
  return (
    <>
      <Router>
        <NavBar />
        <Routes>
          <Route exact path="/" element={<LandingPage />} />{" "}
          <Route exact path="/faq" element={<Faq />} />{" "}
          <Route exact path="/download" element={<Download />} />{" "}
        </Routes>{" "}
        <Footer /> 
      </Router>{" "}
    </>
  );
}

export default App;
